import React from "react";
import { Typography, Button, FormLabel, FormInput } from "../../components";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import useForm from "../../hooks/useForm";
import validate from "../../utilities/validate";
import { ErrorText } from "./signInElements";
import useResetPassword from "../../hooks/useResetPassword";
import { useMutation } from "react-query";
import Alert from "@material-ui/lab/Alert";
import { useHistory, useParams } from "react-router-dom";

const formData = [
  {
    name: "password",
    label: "New Password",
    placeholder: "Enter New password",
    type: "password",
    value: "",
    required: true,
  },
  {
    name: "confirmPassword",
    label: "Confirm Password",
    placeholder: "Confirm password",
    type: "password",
    value: "",
    required: true,
  },
];

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px`,
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography h2>{children}</Typography>
      {/* <Typography body1>Enter below to reset password</Typography> */}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px`,
  },
}))(MuiDialogContent);

export default () => {
  const { values, handleChange, setValues } = useForm(formData);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [formErrors, setFormErrors] = React.useState({});
  const [successMessage, setSuccessMessage] = React.useState("");

  const { token, email } = useParams();
  const history = useHistory();

  const [mutateResetPassword, { isLoading }] = useMutation(useResetPassword, {
    onSuccess: (response) => {
      setSuccessMessage(response.data.message);
      resetFormState();
    },
    onError: (error) => {
      setErrorMessage(error.response.data.message);
    },
  });

  const resetFormState = () => {
    setValues(
      values.map((d) => ({
        ...d,
        value: "",
      }))
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setFormErrors({});
    setErrorMessage("");
    setSuccessMessage("");

    const tempErrors = validate(values);

    if (Object.keys(tempErrors).length) {
      setFormErrors(tempErrors);
    } else {
      const password = values.find((d) => d.name === "password").value;
      const confirmPassword = values.find((d) => d.name === "confirmPassword")
        .value;

      mutateResetPassword({
        email,
        password,
        password_confirmation: confirmPassword,
        token,
      });
    }
  };

  const handleSignIn = () => {
    history.push("/signIn");
  };

  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      open={true}
      maxWidth={false}
    >
      <DialogTitle id="customized-dialog-title">Reset Password</DialogTitle>
      {successMessage && <Alert severity="success">{successMessage}</Alert>}
      {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
      <DialogContent dividers>
        {successMessage ? (
          <div style={{ width: 400 }}>
            <Button marginTop={20} onClick={handleSignIn}>
              Sign In
            </Button>
          </div>
        ) : (
          <form style={{ width: 400 }} onSubmit={handleSubmit}>
            {values.map(
              ({ name, label, placeholder, type, value, required }) => (
                <div key={name}>
                  <FormLabel required={required}>{label}</FormLabel>
                  <FormInput
                    name={name}
                    onChange={handleChange}
                    placeholder={placeholder}
                    value={value}
                    type={type}
                  />
                  {<ErrorText>{formErrors[name]}</ErrorText>}
                </div>
              )
            )}
            <Button marginTop={20} onClick={handleSubmit} isLoading={isLoading}>
              Reset
            </Button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
